import * as actionTypes from '../actions/ActionTypes';
import Config from '../../utils/Configuration';

function initState() {
    if (sessionStorage.getItem(Config.sliceKey.customer)) {
        return {...JSON.parse(sessionStorage.getItem(Config.sliceKey.customer))};
    }
    return {};
}

const initialState = initState();
const updateCustomerDetails = (state, payload) => {
    const updatedState = {
        ...state,
        customerDetails: {...payload}
    };
    sessionStorage.setItem(Config.sliceKey.customer, JSON.stringify(updatedState));
    return updatedState;
};
const updateCustomerIdentificationDetails = (state, payload) => {
    const updatedState = {
        ...state,
        customerIdentificationDetails: {...payload}
    };
    sessionStorage.setItem(Config.sliceKey.customer, JSON.stringify(updatedState));
    return updatedState;
};
const updateCustomerAccountList = (state, payload) => {
    const updatedState = {
        ...state,
        ...payload
    };
    sessionStorage.setItem(Config.sliceKey.customer, JSON.stringify(updatedState));
    return updatedState;
};
const updateBccCheckDetails = (state, payload) => {
    const updatedState = {
        ...state,
        breCheckDetails: {...payload}
    };
    sessionStorage.setItem(Config.sliceKey.customer, JSON.stringify(updatedState));
    return updatedState;
};
const clearCustomer = () => {
    const updatedState = {};
    sessionStorage.setItem(Config.sliceKey.customer, JSON.stringify(updatedState));
    return updatedState;
};
const updateFaceIdDetails = (state, payload) => {
    const updatedState = {
        ...state,
        faceIdDetails: {...payload}
    };
    sessionStorage.setItem(Config.sliceKey.customer, JSON.stringify(updatedState));
    return updatedState;
};

const updateCustomerPersonalDetails = (state, payload) => {
    const updatedState = {
        ...state,
        customerPersonalDetails: {...state.customerPersonalDetails, billingAddress: payload.address}
    };
    sessionStorage.setItem(Config.sliceKey.customer, JSON.stringify(updatedState));
    return updatedState;
};

const updateBizCustomerAccessibleCompany = (state, payload) => {
    const updatedState = {
        ...state,
        bizCustomerAccessibleCompany: {...payload}
    };
    sessionStorage.setItem(Config.sliceKey.customer, JSON.stringify(updatedState));
    return updatedState;
};

const updateBizCustomerAccountList = (state, payload) => {
    const updatedState = {
        ...state,
        bizCustomerAccountList: {...payload}
    };
    sessionStorage.setItem(Config.sliceKey.customer, JSON.stringify(updatedState));
    return updatedState;
};

const updateBizCustomerDetails = (state, payload) => {
    const updatedState = {
        ...state,
        bizCustomerDetails: {...payload}
    };
    sessionStorage.setItem(Config.sliceKey.customer, JSON.stringify(updatedState));
    return updatedState;
};

const updateMbhUserInfo = (state, payload) => {
    const updatedState = {
        ...state,
        mbhUserInfo: {...payload}
    };
    sessionStorage.setItem(Config.sliceKey.customer, JSON.stringify(updatedState));
    return updatedState;
};

const reducer = (state = initialState, action) => {
    const {payload} = action;
    switch (action.type) {
        case actionTypes.UPDATE_CUSTOMER_DETAILS:
            return updateCustomerDetails(state, payload);

        case actionTypes.UPDATE_CUSTOMER_IDENTIFICATION:
            return updateCustomerIdentificationDetails(state, payload);
        case actionTypes.CUSTOMER_ACCOUNT_LIST:
            return updateCustomerAccountList(state, payload);
        case actionTypes.BCC_CHECK_DETAILS:
            return updateBccCheckDetails(state, payload);
        case actionTypes.CLEAR_CUSTOMER:
            return clearCustomer();
        case actionTypes.GET_FACE_ID_DETAILS:
            return updateFaceIdDetails(state, payload);
        case actionTypes.UPDATE_CUSTOMER_PERSONAL_DETAILS:
            return updateCustomerPersonalDetails(state, payload);
        case actionTypes.UPDATE_BIZHUB_CUSTOMER_ACCESSIBLE_COMPANY:
            return updateBizCustomerAccessibleCompany(state, payload);
        case actionTypes.UPDATE_BIZHUB_CUSTOMER_ACCOUNT_LIST:
            return updateBizCustomerAccountList(state, payload);
        case actionTypes.UPDATE_BIZHUB_CUSTOMER_DETAILS:
            return updateBizCustomerDetails(state, payload);
        case actionTypes.UPDATE_MBH_USER_INFO:
            return updateMbhUserInfo(state, payload);
        default:
            return state;
    }
};

export default reducer;
